import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';
import useResponsive from '../../hooks/useResponsive';
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
// config
import { HEADER, NAVBAR } from '../../config';
// components
import DashboardHeader from './header';
import NavbarVertical from './navbar/NavbarVertical';
import NavbarHorizontal from './navbar/NavbarHorizontal';

// ----------------------------------------------------------------------
const SPACING = 8;

const MainStyle = ({ children, sx = {}, ...other }) => {
  const isDesktop = useResponsive('up', 'lg');
  const { isCollapse } = useCollapseDrawer();

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          py: 12,
          width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
          ...(isCollapse && {
            width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
};

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { isCollapse, collapseClick } = useCollapseDrawer();
  const { themeLayout } = useSettings();
  const isDesktop = useResponsive('up', 'lg');
  const [open, setOpen] = useState(false);

  const verticalLayout = themeLayout === 'vertical';

  return (
    <>
      <DashboardHeader isCollapse={isCollapse} onOpenSidebar={() => setOpen(true)} verticalLayout={verticalLayout} />
      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        <NavbarVertical isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        <MainStyle collapseClick={collapseClick}>
          {verticalLayout && isDesktop && <NavbarHorizontal />}
          <Outlet />
        </MainStyle>
      </Box>
    </>
  );
}
